export const getProfessionalDisciplineViewNames = (
  professionalDisciplineName: string
) => {
  switch (professionalDisciplineName.toLowerCase()) {
    case 'building product manufacturer':
      return {
        abbName: 'BPM',
        fullName: 'Building Product Manufacturer Team'
      }
    case 'consultant':
      return {
        abbName: 'CONSU',
        fullName: 'Consultant Team'
      }
    case 'construction':
      return {
        abbName: 'CONST',
        fullName: 'Construction Team'
      }
    case 'civil':
      return {
        abbName: 'CIVIL',
        fullName: 'Civil Team'
      }
    case 'facilities management':
      return {
        abbName: 'FACM',
        fullName: 'Facilities Management Team'
      }
    default:
      return {
        abbName: professionalDisciplineName
          .substring(0, 4)
          .toUpperCase(),
        fullName: `${professionalDisciplineName} Team`
      }
  }
}